import React from 'react';

/** Masonry-style dashboard grid (stroke icon, uses currentColor like react-icons). */
const SidebarDashboardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="2" y="2" width="9" height="11" rx="2" />
    <rect x="13" y="2" width="9" height="7" rx="2" />
    <rect x="2" y="15" width="9" height="7" rx="2" />
    <rect x="13" y="11" width="9" height="11" rx="2" />
  </svg>
);

export default SidebarDashboardIcon;
